<template>
  <div>
    <el-drawer :visible.sync="seeInquiryDetails" :show-close= false class="elDrawer">
      <template v-slot:title>
        <ul class="drawer_title">
          <li>询价单号: {{detailList.OrderNo}}</li>
          <li>
            <el-button type="danger" @click="cancelForm" style="margin-top: -10px;">关 闭</el-button>
          </li>
        </ul>
      </template>
      <div class="drawer_div">
        <!-- 订单信息 -->
        <div class="drawerDiv" v-if="seeInquiryDetails">
          <p>询价概况</p>
          <ul>
            <!-- StatusId -->
            <li>当　前　状　态：<span>{{detailList.StatusName}}</span></li>
            <li>询　价　城　市：<span>{{detailList.InquiryZone}}</span></li>
            <li>剩余报价次数　：<span><strong>{{detailList.QuoteCount}}</strong></span></li>
            <li>询　价　预　算：<span>{{detailList.Budget}}</span></li>
          </ul>

          <p>询价基本信息</p>
          <ul>
            <li>客户电话：<span>{{detailList.CustomerPhone}}</span></li>
            <li>房屋面积：<span>{{detailList.BuildingArea}}</span></li>
            <li>户　　型：<span>{{detailList.HouseType}}</span></li>
            <li>风　　格：<span>{{detailList.Styles}}</span></li>
            <li>询价品类：<span>{{detailList.BrandType}}</span></li>
            <li>询价品牌：<span>{{detailList.Brands}}</span></li>
            <li>图　　片：<span style="cursor: pointer;" @click="seePicture(detailList.InquiryImgs)" :style="{color: detailList.InquiryImgs.length == 0 ? '#ccc' : '#F56C6C'}">
              查看 ({{detailList.InquiryImgs.length}}) 张</span>
            </li>
            <li>备　　注：<span>{{detailList.Remark}}</span></li>
          </ul>

          <p>询价商品</p>
          <ul v-for="(item, index) in detailList.BrandBusinessInquiryForQuerySingleOfGoodsModels" :key="index">
            <li>商品型号：<span>{{item.GoodsCode}}</span></li>
            <li>商品链接: <span>
              <strong id="content" style="color:#00f">{{item.GoodsUrl}}</strong>
              <!-- 复制按钮，利用clipboard.js -->
              <span v-if="item.GoodsUrl" class="copyTrackingNumber" data-clipboard-target="#content" @click="copyTrackingNumber">
                拷贝
              </span>
              </span>
            </li>
            <li>品　　牌: <span>{{item.Brand}}</span></li>
            <li>图　　片：<span style="cursor: pointer;" @click="seePicture(item.GoodsImg)" :style="{color: item.GoodsImg.length == 0 ? '#ccc' : '#F56C6C'}">
              查看 ({{item.GoodsImg.length}}) 张</span></li>
            <li>备　　注：<span>{{item.Remark}}</span></li>
          </ul>

        </div>
        <div class="drawer_foot" v-if="seeInquiryDetails">
          <el-button type="danger" v-if="quoteRecordButton" @click="endQuotationRecord">查看报价记录({{detailList.QuoteCount.substring(1,0)}})</el-button>
          <el-button type="danger" v-if="quoteButton" @click="endOffer">报价({{detailList.QuoteCount}})</el-button>
        </div>
      </div>
    </el-drawer>
    <!-- 商家报价 -->
    <BusinessQuotation :inquiryId="inquiryId" :inquiryNo="inquiryNo" ref="refBusinessQuotation" @closeSee="cancelForm"/>
    <!-- 报价记录 -->
    <QuotationRecord :inquiryId="inquiryId" :inquiryNo="inquiryNo" :dataAllList="dataAllList" ref="refQuotationRecord" @closeSee="cancelForm"/>
    <!-- 查看大图缩略图 -->
    <ViewPicture ref="refViewPicture"/>
  </div>
</template>
<script>
import { getSelectInquiryById, getSelectQuotationByInquiryIdAndUserId, } from "../../api/api";
import BusinessQuotation from './BusinessQuotation';
import QuotationRecord from './QuotationRecord';
import ViewPicture from './ViewPicture';
import ClipboardJS from 'clipboard';
  export default {
    data () {
      return {
        inquiryId: "", // 询价单ID
        inquiryNo: "", // 询价单
        seeInquiryDetails: false, // 抽屉详情
        quoteButton: true, // 报价按钮
        quoteRecordButton: true, // 报价记录按钮
        dataAllList: [], // 报价记录列表
        detailList: [], // 详情基本信息
      }
    },
    components: {
      BusinessQuotation,
      QuotationRecord,
      ViewPicture
    },
    methods: {
      // 初始化
      init (id) {
        this.inquiryId = id;
        var addParams = {
          userId: localStorage.Id, // 当前登陆人ID
          id: this.inquiryId // 询价单ID
        };
        getSelectInquiryById(addParams).then(data => {
          this.detailList = data.ResultObj;
          this.seeInquiryDetails = true;
          this.inquiryNo = this.detailList.OrderNo; // 询价单
          // 显示 报价按钮 & 报价记录按钮: 品牌商员工 & 报价中
          if ( localStorage.UserType != 5 && localStorage.BbId != 1 && this.detailList.StatusId == 1 ) {
            this.quoteButton = true;
            this.quoteRecordButton = true;
          }
          // 不显示 报价按钮 & 报价记录按钮: 甄惠装员工 & 超级管理员
          if ( localStorage.UserType == 5 || localStorage.BbId == 1 || this.detailList.StatusName == '已支付' ) {
            this.quoteButton = false;
            this.quoteRecordButton = false;
          }
          if(this.detailList.StatusName != '报价中' || this.detailList.StatusName == '已中标') {
            this.quoteButton = false;
          }
        })
      },
      //拷贝
      copyTrackingNumber(){
        // 括号中的内容：对应复制按钮的class
        let clipboard = new ClipboardJS('.copyTrackingNumber');
        clipboard.on('success', function(e) {
        console.log("复制成功");
        e.clearSelection();
        });
        clipboard.on('error', function(e) {
        console.log("复制失败，请重试");
        console.log(e)
        });
      },
      // 点击报价
      endOffer() {
        let numOfQuotations = this.detailList.QuoteCount.substring(1,0);
        // 判断报价次数如果满3次 文案提示
        if (numOfQuotations == 3) {
          this.$swal({
            type: "warning",
            text: "您针对一个询价单最多能提交3次报价 ！"
          });
          return
        }
        this.$nextTick(() => {
          this.$refs.refBusinessQuotation.init();
        })
      },
      // 点击查看报价记录
      endQuotationRecord () {
        var addParams = {
          userId: localStorage.Id, // 当前登陆人ID
          inquiryId: this.inquiryId // 询价单ID
        };
        getSelectQuotationByInquiryIdAndUserId(addParams).then(data => {
          this.dataAllList = data.ResultObj;
          if (this.dataAllList.length == 0) {
            this.$swal({
              type: "warning",
              text: "当前询价单您还没有报价！"
            });
            return
          }
          this.$nextTick(() => {
            this.$refs.refQuotationRecord.init();
          })
        })
      },
      // 点击查看询价基本信息缩略图 & 点击查看询价商品缩略图
      seePicture(imgs) {
        if (imgs.length == 0) {
          return false;
        }
        this.$nextTick(() => {
          this.$refs.refViewPicture.init(imgs);
        })
      },
      // 关闭抽屉弹框
      cancelForm() {
        this.seeInquiryDetails = false;
        clearTimeout(this.timer);
        this.$parent.refresh();
      },
    },
  }
</script>
<style>
.elDrawer {
  z-index: 999 !important;
}
</style>
<style scoped>
@import "../../assets/css/drawer.css";
</style>


// WEBPACK FOOTER //
// InquiryDetails.vue?acdc22b4